<div class="btn-container">
  <app-button
    (click)="csvExportParts()"
    [black]="true"
    [title]="'resources.export_parts' | translate"
    class="flex-position-end btn-margin"
    header-button
  >
  </app-button>
</div>

@if (partsList.length) {
  <qs-table
    testId="part-list"
    [data]="partsList"
    [columns]="columns"
    [isSearchEnabled]="isSearchEnabled"
    [expandable]="true"
    [canExpandRow]="hasCounters"
    [columnFilterConfig]="columnFilterConfig"
    [detailTemplate]="counterDetailsTemplate"
  >
  </qs-table>
}

<ng-template #counterDetailsTemplate let-row>
  @if (row.counters?.length) {
    <table class="details-table">
      <thead>
        <tr>
          <th scope="col">
            {{ 'partList.table_header.counter_type' | translate }}
          </th>
          <th scope="col">
            {{ 'partList.table_header.counter' | translate }}
          </th>
          <th scope="col">
            {{ 'partList.table_header.threshold' | translate }}
          </th>
          <th scope="col">
            {{ 'partList.table_header.percentage' | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        @for (detail of row.counters; track detail) {
          <tr
            [class.counter-row--warning]="
              detail.percentage >= 60 && detail.percentage < 80
            "
            [class.counter-row--critical]="detail.percentage >= 80"
          >
            <td class="counter-status-cell">
              {{ detail.type | titleCaseReplace }}
            </td>
            <td class="counter-status-cell">
              {{
                formatCounterValue(
                  detail.value,
                  detail.unit ?? detail.valueType
                )
              }}
            </td>
            <td>
              {{
                formatCounterValue(
                  detail.threshold,
                  detail.unit ?? detail.valueType
                )
              }}
            </td>
            <td class="counter-status-cell">{{ detail.percentage }}</td>
          </tr>
        }
      </tbody>
    </table>
  }
</ng-template>
